import { Instagram } from 'components/main-page/home-page/instagram/Instagram'
import { useEffect, useState } from 'react'
import { useValidation } from 'hooks/useValidation'
import { INSTAGRAM_VALIDATION } from 'services/validation/home-page/instagramValidation'
import { useFetch } from 'services/useFetch'
import { API_INSTAGRAM } from 'services/api-home-page/apiInstagram'
import { convertErrorMessage, uploadFileToS3 } from 'utils/utils'
import { Alert } from 'avo-ui'

const INITIAL_STATE = {
    is_show: false,
    instagram: {
        desktop_background_url: null,
        mobile_background_url: null,
        title: null,
        total: null,
    },
}

const FIELD_NAME_DETAIL = {
    desktop_background_url: 'Background desktop',
    mobile_background_url: 'Background mobile',
    title: 'Title',
    total: 'Total posting',
}

export const InstagramContainer = () => {
    const [reload, setReload] = useState(false)
    const [instagramDetail, setInstagramDetail] = useState(INITIAL_STATE)
    const [isLoadingUpload, setIsLoadingUpload] = useState(false)
    const { fetching: getInstagramDetail, isLoading } = useFetch(API_INSTAGRAM.DETAIL)
    const { fetching: getUrlImageBackground } = useFetch(API_INSTAGRAM.URL_IMAGE_BACKGROUND)
    const { fetching: updateInstagram, isLoading: isUpdating } = useFetch(API_INSTAGRAM.UPDATE)
    const [errorMessage, setErrorMessage] = useState({})
    const { validateForm, errorForm } = useValidation({
        form: instagramDetail?.instagram,
        schema: INSTAGRAM_VALIDATION,
    })

    const onChangeForm = (e) => {
        const { name, value, checked } = e
        let newData
        if (checked === undefined) {
            newData = { instagram: { ...instagramDetail?.instagram, [name]: value } }
        } else {
            newData = { [name]: checked }
        }
        setInstagramDetail({ ...instagramDetail, ...newData })
    }

    const setUploadBackgroundImage = async (filesName, uploadDetail) => {
        const newInstagramDetail = { ...instagramDetail?.instagram }

        try {
            const s3Urls = await getUrlImageBackground({ files: filesName })
            const apiS3list = s3Urls?.data?.map(async (item, i) => {
                await uploadFileToS3(item, uploadDetail[i]?.file)
                newInstagramDetail[uploadDetail[i]?.key] = `${item?.url}${item?.fields?.key}`
            })
            await Promise.all(apiS3list)
            const newDetail = {
                ...instagramDetail,
                instagram: newInstagramDetail,
            }
            onSave(newDetail)
        } catch (err) {
            console.log('upload failed')
        }

        setIsLoadingUpload(false)
    }

    const onSubmit = () => {
        setErrorMessage({})
        validateForm().then(async () => {
            const backgroundImages = [
                instagramDetail?.instagram?.desktop_background_url,
                instagramDetail?.instagram?.mobile_background_url,
            ]
            const uploadDetail = []
            const filesName = []

            backgroundImages.map((item, index) => {
                if (item?.name) {
                    filesName.push(item?.name?.replace(/\s/g, ''))
                    uploadDetail.push({
                        file: item?.file,
                        key: index === 0 ? 'desktop_background_url' : 'mobile_background_url',
                    })
                }
            })

            if (filesName.length) {
                setIsLoadingUpload(true)
                await setUploadBackgroundImage(filesName, uploadDetail)
            } else {
                onSave()
            }
        })
    }

    const onSave = (payload = { ...instagramDetail }) => {
        const newPayload = {
            ...payload,
            instagram: {
                ...payload?.instagram,
                total: Number(payload?.instagram?.total),
            },
        }
        updateInstagram(newPayload)
            .then(() => {
                setReload(!reload)
                return Alert({
                    icon: 'success',
                    title: 'Success',
                    message: 'Instagram Updated !',
                })
            })
            .catch((error) => setErrorMessage(convertErrorMessage(error?.data, FIELD_NAME_DETAIL)))
    }

    useEffect(() => {
        getInstagramDetail().then((response) => setInstagramDetail({ ...response?.data }))
    }, [reload])

    const props = {
        instagramDetail,
        errorForm: { instagram: { ...errorForm, ...errorMessage } },
        onChangeForm,
        isLoading,
        isUpdating,
        isLoadingUpload,
        onSubmit,
    }

    return <Instagram {...props} />
}
